'use strict'
import {
    SIGNUPVALIDATION_FAIL
} from '../constants/SignUpValidationConstants'
import ApplicationConf from '../../conf/ApplicationConf'
import fetch from 'isomorphic-fetch'
import { push } from 'react-router-redux'

const SignUpValidationActions = {
    signUpValidationFail: function (message) {
        return { type: SIGNUPVALIDATION_FAIL, error: message }
    },
    signUpValidation: function (user, token) {
        return function (dispatch) {
            return fetch(ApplicationConf.activatePath() + '/' + user.login + '?token=' + token, {
                method: 'POST',
                headers: {},
                body: JSON.stringify(user)
            })
            .then(() => {
                dispatch(push('/login'))
            }).catch((error) => {
                dispatch(SignUpValidationActions.signUpValidationFail(error.text))
            })
        }
    }
}

export default SignUpValidationActions



// WEBPACK FOOTER //
// ./src/signup/actions/SignUpValidationActions.js